// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".dialog-footer[data-v-dd55179e] {\n  position: absolute;\n  bottom: 0;\n  right: 20px;\n  display: flex;\n  justify-content: flex-end;\n  width: 100%;\n  z-index: 99;\n  background-color: white;\n}\n[data-v-dd55179e] .el-upload-dragger,[data-v-dd55179e] .el-upload {\n  width: 98%;\n}\n.flex[data-v-dd55179e] {\n  display: flex;\n  align-items: flex-end;\n}\n.flex .upload-demo[data-v-dd55179e] {\n  flex: 1;\n  margin-right: 20px;\n}\n", ""]);
// Exports
module.exports = exports;
